import { Component } from '@angular/core';

@Component({
    selector: 'app-faqs-hovers',
    templateUrl: './faqs-hovers.component.html',
    styleUrls: ['./faqs-hovers.component.scss'],
    standalone: false
})
export class FAQsHoversComponent {

  onCloseModal(): void {
    
  }
}
